import React from "react"
import ReactDOM from "react-dom"
import FlightInformationHero from "./flight-information-hero"

export default class FlightInformationHeroModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<FlightInformationHero {...self.elem.dataset} />, self.elem)
  }
}
